import React from 'react';
import { PieChart, Pie, Cell, ResponsiveContainer } from 'recharts';
import { ProjectUnlockData } from '@/types/project';

interface UnlockPieChartProps {
  unlockData: ProjectUnlockData;
  variant?: 'desktop' | 'mobile';
}

const UnlockPieChart: React.FC<UnlockPieChartProps> = ({ unlockData, variant = 'desktop' }) => {
  const isMobile = variant === 'mobile';
  const safeTotalSupply = unlockData.total_supply || 1;

  const pieData = [
    {
      name: 'Unlocked',
      value: unlockData.total_unlocked,
      color: '#c4e804'
    },
    {
      name: 'Locked',
      value: unlockData.total_locked,
      color: '#6b6969'
    }
  ];

  const filteredPieData = pieData.filter(item => item.value > 0);

  const unlockedPercent = Math.round((unlockData.total_unlocked / safeTotalSupply) * 100);
  const lockedPercent = Math.max(0, 100 - unlockedPercent);
  const badgeShadow =
    'shadow-[0px_84px_159px_0px_rgba(0,0,0,0.07),0px_35.093px_66.426px_0px_rgba(0,0,0,0.05),0px_18.762px_35.515px_0px_rgba(0,0,0,0.04),0px_10.518px_19.909px_0px_rgba(0,0,0,0.04),0px_5.586px_10.574px_0px_rgba(0,0,0,0.03),0px_2.324px_4.4px_0px_rgba(0,0,0,0.02)]';

  return (
    <div className="relative w-full h-full">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={filteredPieData}
            cx="50%"
            cy="50%"
            innerRadius={isMobile ? 50 : 86}
            outerRadius={isMobile ? 78 : 132}
            startAngle={332}
            endAngle={-28}
            paddingAngle={2}
            dataKey="value"
            stroke="none"
            strokeWidth={0}
            cornerRadius={isMobile ? 2 : 3}
          >
            {filteredPieData.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={entry.color} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      
      {!isMobile && (
        <>
          <div 
            className={`absolute left-[-16px] top-[174px] h-10 w-10 bg-white border border-[#e0e0e0] rounded-full ${badgeShadow} flex items-center justify-center`}
          >
            <span className="font-['Plus_Jakarta_Sans'] font-medium text-[13px] leading-[18px] text-[#2d2923]">
              {unlockedPercent}%
            </span>
          </div>
          <div 
            className={`absolute left-[274px] top-[81px] h-10 w-10 bg-white border border-[#e0e0e0] rounded-full ${badgeShadow} flex items-center justify-center`}
          >
            <span className="font-['Plus_Jakarta_Sans'] font-medium text-[13px] leading-[18px] text-[#2d2923]">
              {lockedPercent}%
            </span>
          </div>
        </>
      )}
    </div>
  );
};

export default UnlockPieChart;
